<template>
  <div class="contents_wrapper">
    <div class="contents">
      <p class="bold_label">1. アカウントタイプを選択してください</p>
      <div>
        <template v-if="!isCompany">
          <input class="radio_form" type="radio" v-model="stripeParams.account.businessType" value="individual" id="individual">
          <label class="radio-label_form" for="individual">個人</label>
        </template>
        <template v-if="!isIndividual">
          <input class="radio_form" type="radio" v-model="stripeParams.account.businessType" value="company" id="company">
          <label class="radio-label_form" for="company">法人</label>
        </template>
      </div>

      <p class="bold_label">2. アカウント情報を入力してください</p>
      <p v-if="!stripeParams.account.businessType">アカウントタイプの選択後に表示されます。</p>
      <div v-if="stripeParams.account.businessType === 'company'">
        <VerifyingCompany :company="stripeParams.account.company" @setTempPostalCode="setTempCompanyPostalCode"/>
        <VerifyingPerson :person="stripeParams.account.person" @setTempPostalCode="setTempPersonPostalCode"/>
      </div>
      <VerifyingIndividual
        v-if="stripeParams.account.businessType === 'individual'"
        :individual="stripeParams.account.individual"
        @setTempPostalCode="setTempIndividualPostalCode"
      />

      <p class="bold_label">3. 本人確認書類を登録してください（2MB以下の画像で登録してください）</p>
      <p>表面</p>
      <UploaderServerlessFormBox v-model="stripeParams.files.front"/>

      <p>裏面</p>
      <UploaderServerlessFormBox v-model="stripeParams.files.back"/>

      <p class="bold_label">4. 利用規約を確認してください</p>
      <p><input type="checkbox" class="" id="terms_check_id" v-model="isTermsCheck"/>
        <label for="terms_check_id"> 私は<a target="_blank" href="/information/terms" class="link_label">利用規約</a>に同意します。</label>
      </p>
      <p><input type="checkbox" class="" id="stripe_terms_check_id" v-model="isStripeTermsCheck"/>
        <label for="stripe_terms_check_id">本アプリは決済・入金に外部決済サービスを利用します。<a target="_blank" href="https://stripe.com/jp/legal" class="link_label">外部決済サービスの利用規約</a>を確認の上、同意する場合はチェックしてください。</label>
      </p>

      <button v-if="isTermsCheck && isStripeTermsCheck" class="active-rectangle_button" @click="verifyAccount()">アカウントの認証をする</button>
      <button v-else class="inactive-rectangle_button">利用規約に同意してください</button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import caller from '@/assets/js/functions/firebase/cloud_functions/caller.js';
  import toast from "@/assets/js/functions/_core/toast";

  import VerifyingCompany from "@/components/objects/stripe/account/VerifyingCompany";
  import VerifyingPerson from "@/components/objects/stripe/account/VerifyingPerson";
  import VerifyingIndividual from "@/components/objects/stripe/account/VerifyingIndividual";
  import UploaderServerlessFormBox from "@/components/molecules/box/form/UploaderServerlessFormBox";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";

  export default {
    name: "RegistrationCustomAccount",

    components: {VerifyingIndividual, VerifyingPerson, VerifyingCompany, UploaderServerlessFormBox},

    mixins: [caller, toast, collection],
    data() {
      return {
        isTermsCheck: false,
        isStripeTermsCheck: false,
        operatorStripe: {},
        tempIndividualPostalCode: '',
        tempCompanyPostalCode: '',
        tempPersonPostalCode: '',

        stripeParams: {
          account: {
            businessType: '',
            company: {
              name: '',
              name_kana: '',
              name_kanji: '',
              phone: '',
              tax_id: '',
              address_kana: {
                country: 'JP',
                state: '',
                city: '',
                town: '',
                line1: '',
                line2: '',
                postal_code: '',
              },
              address_kanji: {
                country: 'JP',
                state: '',
                city: '',
                town: '',
                line1: '',
                line2: '',
                postal_code: '',
              },
            },
            person: {
              first_name: '',
              last_name: '',
              first_name_kanji: '',
              last_name_kanji: '',
              first_name_kana: '',
              last_name_kana: '',
              gender: '',
              email: '',
              dob: {
                year: '',
                month: '',
                day: '',
              },
              address_kana: {
                country: 'JP',
                state: '',
                city: '',
                town: '',
                line1: '',
                line2: '',
                postal_code: '',
              },
              address_kanji: {
                country: 'JP',
                state: '',
                city: '',
                town: '',
                line1: '',
                line2: '',
                postal_code: '',
              },
            },
            individual: {
              first_name_kana: '',
              first_name_kanji: '',
              gender: '',
              last_name_kana: '',
              last_name_kanji: '',
              dob: {
                year: '',
                month: '',
                day: '',
              },
              address_kana: {
                country: 'JP',
                state: '',
                city: '',
                town: '',
                line1: '',
                line2: '',
                postal_code: '',
              },
              address_kanji: {
                country: 'JP',
                state: '',
                city: '',
                town: '',
                line1: '',
                line2: '',
                postal_code: '',
              },
            },
          },
          files: {
            front: null,
            back: null,
          },
        },
      }
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      await this.getDoc(
        COLLECTION_NAMES.OPERATOR_STRIPES,
        this.uid,
        {}).then(async operatorStripe => {
        this.operatorStripe = operatorStripe;
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),

      isCompany() {
        return !!this.operatorStripe.companyId
      },

      isIndividual() {
        return !!this.operatorStripe.individualId
      },

      isValid() {
        if (!this.stripeParams.account.businessType) {
          this.showErrorMessage('未入力のデータがあります。');
          return false;
        } else if (!this.stripeParams.files.front || !this.stripeParams.files.back) {
          this.showErrorMessage('本人確認書類を登録してください。');
          return false;
        }
        return true;
      },
    },

    methods: {
      async verifyAccount() {
        await this.setPostalCode();

        if (!this.isValid) return;

        const params = {
          userId: this.uid,
          stripeParams: this.stripeParams
        };

        await this.callFunction(
          'verifyStripeCustomAccount',
          params
        ).then(() => {
          this.showSuccessMessage('入金アカウント情報を更新しました。');
          this.$router.push({name: 'PaymentTop'});
        }).catch(error => {
          this.showErrorMessage(error.message);
        });
      },

      setTempCompanyPostalCode(postalCode){
        this.tempCompanyPostalCode = postalCode;
      },
      setTempPersonPostalCode(postalCode){
        this.tempPersonPostalCode = postalCode;
      },
      setTempIndividualPostalCode(postalCode){
        this.tempIndividualPostalCode = postalCode;
      },
      setPostalCode(){
        this.stripeParams.account.company.address_kana.postal_code = this.tempCompanyPostalCode;
        this.stripeParams.account.company.address_kanji.postal_code = this.tempCompanyPostalCode;
        this.stripeParams.account.person.address_kana.postal_code = this.tempPersonPostalCode;
        this.stripeParams.account.person.address_kanji.postal_code = this.tempPersonPostalCode;
        this.stripeParams.account.individual.address_kana.postal_code = this.tempIndividualPostalCode;
        this.stripeParams.account.individual.address_kanji.postal_code = this.tempIndividualPostalCode;
      }
    },

  }
</script>


<style lang="scss" scoped>
  .contents_wrapper {
    background-color: $operator_primary;

    > .contents {
      > div, > p, .uploader-serverless-form_box, .verifying-person, .verifying-company, .verifying-individual {
        width: 100%;
      }

      @include form-contents();
    }
  }
</style>